(function () {
  const SEARCH_REGEXP = /search=(.*)/

  const removeHash = function() {
    history.pushState('', document.title, window.location.pathname + window.location.search)
  }

  const setupSearchByTag = function() {
    const searchByTags = document.querySelectorAll('[data-js="search-tag"]')
    searchByTags.forEach((el) => {
      el.onclick = (evt) => {
        const searchField = evt.target.closest('.header__drawer__content').querySelector('input')
        searchField.value = evt.srcElement.innerText
        // field focused when drawer is opened
        // searchField.dispatchEvent(new Event('keyup'))
        searchField.form.querySelector('button').click()
      }

      el.onkeydown = (evt) => {
        if (evt.key === 'Enter' || evt.keyCode === '13') {
          const searchField = evt.target.closest('.header__drawer__content').querySelector('input')
          searchField.value = evt.srcElement.innerText
          // field focused when drawer is opened
          // searchField.dispatchEvent(new Event('keyup'))
          searchField.form.querySelector('button').click()
        }
      }
    })
  }

  const createSearch = function(input, button, loadedTerm) {
    const ghostSearch = new GhostSearch({
      key: config.ghost_key,
      url: config.ghost_url,
      input,
      button,
      version: 'v3',
      template: function (result) {
        let postImage = ''

        const date = new Date(result.published_at)

        const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
        const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(date)
        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)

        const modifiedDate = `${da} ${mo} ${ye}`

        const searchResult = `
          <div class="card search__result">
            <a class="card__image" href="${result.url}" title="${result.title}" aria-label="${result.title}">
              <img src="${result.feature_image}" alt="${result.title} featured image"/>
            </a>

          <div class="card__content">
            <div class="card__header">
              <a class="card__tag" href="${result.tags[0].url}" title="${result.tags[0].name}" aria-label="${result.tags[0].name}">#${result.tags[0].name}</a>
              <div class="card__visibility public">members</div>

            </div>

            <h2 class="card__title">
              <a href="${result.url}" title="${result.title}" aria-label="${result.title}">${result.title}</a>
            </h2>

            <div class="card__excerpt">${result.excerpt}</div>

            <div class="card__details">
              <div class="card__authors ">
                  <div class="card__author 1">
                      <a href="${result.authors[0].url}" class="card__author-image" aria-label="${result.authors[0].name}">
                        <img alt="${result.authors[0].name}" src="${result.authors[0].profile_image}">
                      </a>
                  </div>
              </div>

              <div class="card__info">
                <div class="card__author-names">
                  By <a href="${result.authors[0].url}">${result.authors[0].name}</a>
                </div>

                <time datetime="${result.published_at}" class="card__date">
                  ${modifiedDate}
                </time>
              </div>
            </div>
          </div>
        </div>
        `

        return searchResult
      },
      trigger: 'focus',
      options: {
        keys: ['title', 'authors.0.name', 'tags.0.name', 'tags.1.name', 'tags.2.name', 'tags.3.name', 'tags.4.name']
      },
      api: {
        resource: 'posts',
        parameters: {
          limit: 'all',
          fields: ['title', 'slug', 'published_at', 'feature_image', 'excerpt', 'url'],
          filter: '',
          include: ['tags', 'authors'],
          order: '',
          formats: 'plaintext'
        }
      },
      on: {
        beforeDisplay: function () {
          const input = document.querySelector(ghostSearch.input)
          if (!input) {
            console.warn('no input for search value')
            return
          }

          if (!input.value) {
            removeHash()
            return
          }

          location.hash = `search=${encodeURIComponent(input.value)}`

          const main = document.querySelector('main')
          main.classList.add('search--active')
          const search = document.querySelector('.search')
          search.classList.add('search--active')
          const searchHeader = document.querySelector('.search__header')
          searchHeader.textContent = `Search results for ”${decodeURIComponent(input.value)}”`
        },
        afterDisplay: function(results) {
          // close search drawer on results
          const searchActivator = document.querySelector('[data-js-drawer-target="Search"]')
          if (searchActivator) {
            console.log('searchActivator', searchActivator)
            searchActivator.dispatchEvent(new Event('mouseleave'))
          }

          // close hamburger menu on results
          const hamburgerActivator = document.querySelector('[data-js="hamburger"]')
          if (hamburgerActivator) {
            hamburgerActivator.dispatchEvent(new Event('click'))
            hamburgerActivator.click()
          }
        },
      },
      ...(loadedTerm && { defaultValue: decodeURIComponent(loadedTerm) })
    })

    return ghostSearch
  }

  const onHashChange = function(event) {
    const searchMatches = location.hash.match(SEARCH_REGEXP)
    if (!searchMatches) {
      const main = document.querySelector('main')
      main.classList.remove('search--active')
      const search = document.querySelector('.search')
      search.classList.remove('search--active')
    }
  }

  const onLoad = function() {
    const searchForms = document.querySelectorAll('#search-form')
    console.log('searchForms', searchForms)
    for (const searchForm of searchForms) {
      searchForm.addEventListener('submit', function (e) {
        // console.log('activator', document.querySelector('[data-js-drawer="Search"]'))
        // const searchActivator = document.querySelector('[data-js-drawer="Search"]')
        // if (searchActivator) {
        //   console.log('activator', searchActivator)
        //   searchActivator.click()
        // }
        e.preventDefault()
      }, true)
    }

    const searchMatches = location.hash.match(SEARCH_REGEXP)
    const searchTerm = searchMatches && searchMatches[1]

    createSearch('#ghost-search-field', '#ghost-search-button', searchTerm)
    createSearch('#ghost-search-field-mobile', '#ghost-search-button-mobile', searchTerm)
    setupSearchByTag()
  }

  document.addEventListener('DOMContentLoaded', onLoad)
  window.addEventListener('hashchange', onHashChange)
}())